import React from 'react';
import { Link } from 'react-router-dom';
import SeoHead from '../components/SeoHead';

export default function ForbiddenPage() {
  return (
    <>
      <SeoHead
        title="403 – Ingen adgang – Ibjerget"
        description="Du har ikke adgang til denne side på Ibjerget."
      />

      <section className="min-h-[80vh] flex items-center justify-center py-28 px-4 bg-[#FAF5F9]">
        <div className="max-w-xl mx-auto text-center bg-white rounded-3xl p-8 sm:p-12 border border-[#EDD5E8] shadow-sm space-y-6">
          <div className="w-16 h-16 mx-auto rounded-full bg-[#F0D9EB] text-[#D9238C] flex items-center justify-center text-2xl">
            <i className="fa-solid fa-lock" aria-hidden="true"></i>
          </div>

          <span className="text-xs font-semibold uppercase tracking-widest text-[#D9238C] block">
            Fejl 403
          </span>

          <h1 className="font-serif text-3xl sm:text-4xl font-semibold text-[#1f142e]">
            Adgang nægtet
          </h1>

          <p className="text-sm text-[#4E3568] leading-relaxed">
            Du har desværre ikke tilladelse til at tilgå denne side på Ibjerget.
          </p>

          <div className="pt-4 flex flex-wrap justify-center gap-4">
            <Link
              to="/"
              className="px-6 py-3 rounded-full bg-[#D9238C] hover:bg-[#BE1878] text-white text-xs font-semibold shadow transition-colors"
            >
              Gå til Forsiden
            </Link>
            <Link
              to="/kontakt"
              className="px-6 py-3 rounded-full bg-[#FAF5F9] hover:bg-[#F0D9EB] text-[#1f142e] text-xs font-semibold border border-[#EDD5E8] transition-colors"
            >
              Kontakt Ibjerget
            </Link>
          </div>
        </div>
      </section>
    </>
  );
}
